module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.rescherdulingState.isPopupShown) ? _c('div', {
    attrs: {
      "id": "reschedulingPopup"
    }
  }, [_c('p', [_vm._v("振替依頼をする")]), _vm._v(" "), _c('section', [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.candidateDatetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.candidateDatetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-body"
    }, [_c('a', [_vm._v("日付　　:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.date),
        expression: "cand.date"
      }],
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (cand.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "date", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('a', [_vm._v("開始時間:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.startTime),
        expression: "cand.startTime"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (cand.startTime)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "startTime", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('a', [_vm._v("終了時間:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.endTime),
        expression: "cand.endTime"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (cand.endTime)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "endTime", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.duration),
        expression: "cand.duration"
      }],
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (cand.duration)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cand, "duration", $event.target.value)
        }
      }
    }), _c('a', [_vm._v("分間")])])])])
  })), _vm._v(" "), _c('input', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "value": "＋ 候補日時を追加する"
    },
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  })]), _vm._v(" "), _c('section', [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("理由を入力してください（必須）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', [_c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "確認する"
    },
    on: {
      "click": _vm.onConfirmButtonClicked
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "cancel"
    },
    on: {
      "click": _vm.closePopup
    }
  })]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-31af4561", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31af4561"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/timetable/boxes/SpReschedulingPopup.vue
// module id = 688
// module chunks = 0